// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"f0b5f77a","296":"28b35a68","467":"496c06e2","793":"7c1bf45d","838":"779cf5a3"}[chunkId] + ".chunk.css";
};